import { VEC2, type AABB } from 'math'
import type { KnobObject } from './Knob'
import type { KnobLine } from './types'

export const computeKnobLines = (
  knobs: KnobObject[],
  bound: AABB,
  colors: string[]
): KnobLine[] => {
  if (knobs.length <= 0) return []
  let a = knobs[0]

  const lines: KnobLine[] = [
    {
      bound,
      knobA: {
        position: VEC2(0, a.pos.y),
        dragging: false,
        color: colors[colors.length - 1],
        uid: a.uid
      },
      knobB: {
        position: a.pos,
        dragging: a.dragging,
        color: a.color,
        uid: `${a.uid}-b`
      }
    }
  ]

  for (let i = 1; i < knobs.length; i++) {
    const b = knobs[i]

    const next = {
      knobA: a.toItem(),
      knobB: b.toItem(),
      pa: a.pos,
      pb: b.pos,
      bound: bound
    }
    lines.push(next)
    a = b
  }

  lines.push({
    bound,
    knobA: lines[lines.length - 1].knobB,
    knobB: {
      position: VEC2(bound.max.x, a.pos.y),
      dragging: false,
      color: colors[0],
      uid: `--${lines.length}`
    }
  })

  return lines
}
